var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 10.342H22.5V8.274c0-2.194-.79-4.299-2.197-5.85C18.897.871 16.99 0 15 0c-1.99 0-3.897.872-5.303 2.423C8.29 3.975 7.5 6.08 7.5 8.274v2.069H3.75c-.994 0-1.948.437-2.65 1.212-.704.776-1.1 1.828-1.1 2.925v14.479c0 1.097.396 2.149 1.1 2.924.702.776 1.656 1.212 2.65 1.213h22.5c.994 0 1.948-.437 2.65-1.213.704-.775 1.1-1.827 1.1-2.924v-14.48c0-1.096-.396-2.148-1.1-2.924-.702-.775-1.656-1.212-2.65-1.213Zm-10 13.101c0 .493-.238.948-.625 1.194a1.15 1.15 0 0 1-1.25 0c-.387-.246-.625-.701-.625-1.194v-3.448c0-.492.238-.947.625-1.194a1.15 1.15 0 0 1 1.25 0c.387.247.625.702.625 1.195v3.447ZM10 8.274c0-1.97.953-3.792 2.5-4.777a4.598 4.598 0 0 1 5 0c1.547.985 2.5 2.806 2.5 4.777v2.069H10V8.273Z",
    fill: "currentColor"
  })));
};

export default SvgLock;